// NATIVE 
import React from 'react';

// INSTALLED 
import { Link } from 'react-router-dom'
import { Breadcrumbs, Divider, Typography } from '@mui/material'
import { ITitlesAndBreadcrumbs } from '../../commons/interfaces/titleAndBreadcrumds.interface';

// CUSTOM 




export const BreadCrumbsAndTitle = ({ title, mainModule, parent, action  }:ITitlesAndBreadcrumbs) => {
  return (

    <>
        <div style={{ marginTop: 20 }}></div>
        <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>{title}</Typography>
        <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
        <Typography color="textPrimary" sx={{ fontWeight: 700 }}>{mainModule}</Typography>

        {
          action != '' && <Link color="inherit" to={action}>
                              {parent} 
                          </Link>
        }
        
        <Typography color="textPrimary">{title}</Typography>
        </Breadcrumbs> 
        
    </>
   
  )
}
